import { render, staticRenderFns } from "./customFunction.vue?vue&type=template&id=3ae28e5b"
import script from "./customFunction.vue?vue&type=script&lang=js"
export * from "./customFunction.vue?vue&type=script&lang=js"
import style0 from "./customFunction.vue?vue&type=style&index=0&id=3ae28e5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports